import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-trail-test-start-popup',
  templateUrl: './trail-test-start-popup.component.html',
  styleUrls: ['./trail-test-start-popup.component.scss']
})
export class TrailTestStartPopupComponent implements OnInit {

  @Input() popup:any = {};

  constructor(private ngbActiveModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  startTest() {
    this.closeModel({ status : 'start'});
  }

  closeModel(data = null) {
    this.ngbActiveModal.close(data);
  }

}
